export default __webpack_public_path__ + "static/goodthings22_logo-b7fc6fba21eb4a4bd9f5f9eb94861001.png";